import { render, staticRenderFns } from "./FooterTemplateForm.vue?vue&type=template&id=75da4540&"
import script from "./FooterTemplateForm.vue?vue&type=script&lang=js&"
export * from "./FooterTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports